import { get } from "./api";
import routes from "./end-points";

export const homeApi = {
    initHome: () => get(routes.home.initHome),
};
